import { getTankWaterHealthData } from '../../../../calculatedStateUtils'
//  import { Position } from '../../../types/PayloadTypes/PositionType'
const locale = 'en-NZ'
const debug = !process.env.AWS_SESSION_TOKEN && false

export const getTankWaterAvailabilityData = (tankList: any) => {
  const getAvailabilityDataDebug = true
  // const combinedFillFactor: number = tankList.reduce((acc: number, curr: any) => typeof curr.current_filled_factor === 'number' ? acc + curr.current_filled_factor :
  //     typeof curr.current_filled_factor === 'string' ? acc + parseInt(curr.current_filled_factor) : acc, 0)
  // const aggregateFillFactor: number = combinedFillFactor / tankList.length
  // const aggregateFillPercentage: number = aggregateFillFactor * 100

  const current_filled_volume: number = tankList.reduce(
    (acc: number, curr: any) =>
      typeof curr.current_filled_volume === 'number'
        ? acc + curr.current_filled_volume
        : typeof curr.current_filled_volume === 'string'
          ? acc + parseInt(curr.current_filled_volume)
          : acc,
    0,
  )

  const total_volume: number = tankList.reduce(
    (acc: number, curr: any) =>
      typeof curr._totalVolume === 'number' ? acc + curr._totalVolume : typeof curr._totalVolume === 'string' ? acc + parseInt(curr._totalVolume) : acc,
    0,
  )
  const aggregateFillPercentage: number = Math.round((current_filled_volume / total_volume) * 100)
  const TankWaterAvailabilityData: any = getTankWaterHealthData(aggregateFillPercentage)
  debug && getAvailabilityDataDebug && console.log({ current_filled_volume, total_volume, aggregateFillPercentage, TankWaterAvailabilityData })
  return TankWaterAvailabilityData
}

export const getAggregateCollectionVolume = (tankList: any) => {
  const grpAggCollVolumeDebug = false
  let groupAggregateCollectionVolume: number = 0
  if (tankList.length > 0) {
    tankList.forEach((tank: any) => {
      debug && grpAggCollVolumeDebug && console.log(tank)
      if (tank.forecastCollectionInSevenDays) groupAggregateCollectionVolume += tank.forecastCollectionInSevenDays
    })
  }
  return groupAggregateCollectionVolume
}
